import Tabprum from "../../../models/order/tabprum.model";

interface DiscountLimitInput {
  conditionId?: string | null;
  quantity: number;
  tableLimit: number;
  tabprum?: Tabprum[];
  unit?: string | null;
}

const normalizeId = (value?: string | number | null): string =>
  String(value ?? "").trim();

const normalizeUnit = (value?: string | null): string =>
  String(value ?? "")
    .trim()
    .toUpperCase();

const normalizeQuantity = (value: number | string): number => {
  if (typeof value === "number") {
    return value;
  }
  return parseFloat(value.replace(",", "."));
};

const tabprumDiscountLimit = ({
  conditionId,
  quantity,
  tableLimit,
  tabprum,
  unit,
}: DiscountLimitInput): number => {
  const normalizedConditionId = normalizeId(conditionId);
  const normalizedUnit = normalizeUnit(unit);
  const normalizedQuantity = normalizeQuantity(quantity);
  let fallbackReason = "";

  if (!normalizedConditionId) {
    fallbackReason = "sem condicao de pagamento";
  } else if (!normalizedUnit) {
    fallbackReason = "sem unidade de medida";
  } else if (!tabprum || tabprum.length === 0) {
    fallbackReason = "tabprum vazio";
  } else if (Number.isNaN(normalizedQuantity)) {
    fallbackReason = "quantidade invalida";
  }

  if (fallbackReason) {
    console.log("[tabprumDiscountLimit]", {
      conditionId,
      normalizedConditionId,
      unit,
      normalizedUnit,
      quantity,
      normalizedQuantity,
      tableLimit,
      totalRules: tabprum?.length || 0,
      matchedRules: [],
      matchingRule: null,
      resolvedLimit: tableLimit,
      fallbackReason,
    });
    return tableLimit;
  }

  const tabprumRules = tabprum || [];

  const rules = tabprumRules
    .map((rule) => ({
      ...rule,
      quantidade: normalizeQuantity(rule.quantidade),
    }))
    .filter(
      (rule) =>
        normalizeId(rule.idTabprum) === normalizedConditionId &&
        normalizeUnit(rule.unidadeMedida) === normalizedUnit &&
        !Number.isNaN(rule.quantidade),
    )
    .sort((a, b) => a.quantidade - b.quantidade);

  if (rules.length === 0) {
    console.log("[tabprumDiscountLimit]", {
      conditionId,
      normalizedConditionId,
      unit,
      normalizedUnit,
      quantity,
      normalizedQuantity,
      tableLimit,
      totalRules: tabprum?.length || 0,
      matchedRules: [],
      matchingRule: null,
      resolvedLimit: tableLimit,
      fallbackReason: "sem regra compativel",
    });
    return tableLimit;
  }

  const matchingRule = rules.find(
    (rule) => normalizedQuantity <= rule.quantidade,
  );

  if (!matchingRule) {
    console.log("[tabprumDiscountLimit]", {
      conditionId,
      normalizedConditionId,
      unit,
      normalizedUnit,
      quantity,
      normalizedQuantity,
      tableLimit,
      totalRules: tabprum?.length || 0,
      matchedRules: rules,
      matchingRule: null,
      resolvedLimit: 99.9,
      fallbackReason: "quantidade acima da maior regra",
    });

    return 99.9;
  }

  return matchingRule.desconto;
};

export default tabprumDiscountLimit;
